import { I1379Form } from 'clickNgo/models/crud/forms/i1379Form'
import { IGlobalPartner } from 'clickNgo/models/globalPartner'

export const mapGlobalPartnerFrom1379Crud = (data: I1379Form): IGlobalPartner => ({
  detailedManagersInfo: data.Managers ? data.Managers.split(',').map((email) => ({ email })) : [],
  detailedPBMInfo: data.PBM ? data.PBM.split(',').map((email) => ({ email })) : [],
  entryId: data.EntryId,
  globalPartnerId: data.GlobalPartnerId,
  globalPartnerName: data.GlobalPartnerName,
  globalPartnerType: data.RTM,
  managers: data.Managers?.split(',') || [],
  pbm: data.PBM?.split(',') || [],
  hqPartnerId: data.HQPartnerId,
  isIts: data.IsITS,
  isReflectOnDashboards: data.IsReflectOnDashboards,
})
